// extracted by mini-css-extract-plugin
export var divider = "_ew-7";
export var itemsToggle = "_ew-8";
export var mergeModal = "_ew-1";
export var optionCard = "_ew-4";
export var radioGroup = "_ew-6";
export var radioOption = "_ew-0";
export var selected = "_ew-5";
export var shipmentOptions = "_ew-2";
export var tableOptions = "_ew-3";